module.exports = __webpack_public_path__ + "img/xmjkzxt4.21f141d8.jpg";